import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function BreadcrumbPedidos({active}) {

    return <Breadcrumb>
            <Breadcrumb.Item><Link to="/">Inicio</Link></Breadcrumb.Item>
            <Breadcrumb.Item><Link to="/pedidos">Pedidos</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>{active}</Breadcrumb.Item>
        </Breadcrumb>
    
}